<template>
  <div
    :class="['tab-item', { 'disable': disabled, 'cur': isCur }]"
    @click.stop="tabClick">
    <!-- 使用slot,方便外部自定义tab标题展示 -->
    <slot :tab="tabData">{{ curTitle }}</slot>
  </div>
</template>

<script>
export default {
  name: 'MonitTabItem',
  props: {
    value: {
      type: String,
      default: ''
    },
    tabData: {
      type: Object,
      required: true,
      default () { return {} }
    },
    disabled: { // 当前tab是否禁用
      type: Boolean,
      default: false
    },
    option: { // 指定用作tab项name和title的属性名(默认就是name和title)
      type: Object,
      default () {
        return {
          name:'name', // tab项唯一标识符
          title:'title' // tab项标题
        }
      }
    }
  },
  computed: {
    selectedTab: { // 当前选中的tab项对应的name值
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    curName () {
      return this.tabData[this.option.name]
    },
    curTitle () {
      return this.tabData[this.option.title]
    },
    isCur () {
      if (this.disabled) return false
      return this.selectedTab === this.curName
    }
  },
  methods: {
    tabClick () {
      if (this.disabled) return // 当前tab禁用
      if (this.selectedTab === this.curName) return // 点击已选中tab，不做任何操作
      this.$emit('tabChange', this.curName)
      this.$emit('input', this.curName) // 更新当前选中tab项的name值到外部
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

